module.exports = "<div class=\"card-overflow col-12\">\n  <div class=\"card-front\">\n    <ng-content select=\"card-front\" ></ng-content>\n  </div>\n  <div class=\"card-revealed\" *ngIf=\"show\" [@socialsState]=\"socials\" >\n    <ng-content select=\"card-revealed\" ></ng-content>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/typescripts/pro/cards/card-reveal.component.html
// module id = ./src/app/typescripts/pro/cards/card-reveal.component.html
// module chunks = main